module.exports = __webpack_public_path__ + "img/collection-weddingRingsBestseller@2x.cd59839.webp";